import type {DropdownMenuItemMixed} from '@gravity-ui/uikit';
export const useAdditionalWorkbookEntryActions = (): DropdownMenuItemMixed<unknown>[] => {
    return [];
};
